module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_326.25deg.d8a3803b.png";